import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    title: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.title',
        defaultMessage: 'Your blended rate'
    },
    description: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.description',
        defaultMessage:
            "The rate on your existing principal won't change - we'll combine this with any new funds into a single loan and calculate a blended rate for you, as outlined below."
    },
    accordionTitle: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.accordion_title',
        defaultMessage: 'How is this calculated'
    },
    accordionDescription: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.accordion_description',
        defaultMessage: 'We calculate your blended rate using the follow steps:'
    },
    descriptionListItemOne: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.description_list_item_one',
        defaultMessage: 'Multiply your existing principal by your current rate:'
    },
    formulaListItemOne: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.formula_list_item_one',
        defaultMessage:
            '{principal_pre_funding} × {rate_on_pre_funding_principal}'
    },
    descriptionListItemTwo: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.description_list_item_two',
        defaultMessage:
            'Multiply your new funds by your new rate, and add this to the amount above:'
    },
    formulaListItemTwo: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.formula_list_item_two',
        defaultMessage:
            '({newFundingAmount} × {rate_on_funding_amount}) + ({principal_pre_funding} × {rate_on_pre_funding_principal})'
    },
    descriptionListItemThree: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.description_list_item_three',
        defaultMessage: 'Divide this by your new outstanding balance:'
    },
    formulaListItemThree: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.formula_list_item_three',
        defaultMessage:
            '(({newFundingAmount} × {rate_on_funding_amount}) + ({principal_pre_funding} × {rate_on_pre_funding_principal})) ÷ ({principal_pre_funding} + {newFundingAmount})'
    },
    existingPrincipal: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.existing_principal',
        defaultMessage: 'Existing principal'
    },
    newFunds: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.new_funds',
        defaultMessage: 'New funds'
    },
    newLoanPrincipal: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.new_loan_principal',
        defaultMessage: 'New loan principal'
    },
    replacementText: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.replacementText',
        defaultMessage: 'This will replace your existing loan'
    },
    at: {
        id: '_.outstanding_view.dashboardActionPanel.blended_rate_summary.at',
        defaultMessage: 'at'
    }
});
